import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const MeetingTranscriptCreatedSchema = z.object({
    artifactKey: z.string(),
    entityId: CornSchema,
});
